<template>
    <div class="card" style="width: 22rem;">
        <div class="card-body">
            <h5 class="card-title">Other</h5>
            <hr />
            <div v-if="policyDetails">
                <!--<span>{{policyDetails}}</span>-->
                <div class="row">
                    <div class="col">
                        <p class="card-text font-weight-bold">Policy use</p>
                    </div>
                    <div class="col">
                        <p class="card-text font-weight-light">{{PolicyUseType}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="card-text font-weight-bold">FCDO Cover</p>
                    </div>
                    <div class="col">
                        <p class="card-text font-weight-light">{{isFCDOCoverAdded}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="card-text font-weight-bold">Optional cover</p>
                    </div>
                    <div class="col">
                        <p class="card-text font-weight-light">{{isOptional}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="card-text font-weight-bold">Renewal</p>
                    </div>
                    <div class="col">
                        <p class="card-text font-weight-light">{{isRenewal}}</p>
                    </div>
                </div>
            </div>
            <div  v-else class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PolicyOther',
        data: () => {
            return {

            }
        },
        computed: {
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            policyDetails() {
                return this.selectedClaim.policyDetails
            },
            isOptional() {
                if (this.policyDetails && this.policyDetails.isMandatory !== null) {
                    return this.formatBool(!this.policyDetails.isMandatory)
                }
                return 'UNKNOWN'
            },
            isFCDOCoverAdded() {
                if (this.policyDetails && this.policyDetails.isFCDOCoverAdded !== null) {
                    return this.formatBool(this.policyDetails.isFCDOCoverAdded)
                }
                return 'UNKNOWN'
            },
            PolicyUseType() {
                if (this.policyDetails && this.policyDetails.policyUseTypeId !== null) {
                    return this.policyDetails.policyUseTypeLabel
                }
                return 'UNKNOWN'
            },
            isRenewal() {
                if (this.policyDetails && this.policyDetails.leadTypeId !== null) {
                    if (this.policyDetails.leadTypeId == 4)
                        return 'YES'
                    else
                        return 'NO'
                }

                if (this.policyDetails.resellerId != 105 &&  this.selectedClaim)
                    if (this.selectedClaim.previousQuoteId)
                        return 'YES'
                    else
                        return 'NO'
                
                return 'UNKNOWN'
            },
        },
        methods: {
            formatBool(val) {
                if (val === true) {
                    return 'YES'
                } else if (val === false) {
                    return 'NO'
                } else {
                    return 'UNKNOWN'
                }
            }
        }
    }
</script>